import React from 'react'
import { Button } from '@/components/ui/button'
import { SymbolDto } from 'api/MetaTrader/SymbolDto'
import {
  FormBaseButtonContainer,
  FormBaseContainer,
  FormBaseErrorMessage,
  FormBaseFieldBlock,
  FormBaseFieldGroup,
  FormBaseFieldLabel,
  FormBaseRow,
} from 'components/Form/Form.styles'
import { Field, Form, FormikErrors, FormikProps, withFormik } from 'formik'

interface OuterProps {
  data: SymbolDto

  onSubmit(values: EditSymbolFormValues): void
}

const BrokeragePlatformSwapsFormUI: React.FC<FormikProps<EditSymbolFormValues>> = (props) => {
  const { handleSubmit, validateForm, errors } = props

  return (
    <FormBaseContainer>
      <Form onSubmit={handleSubmit}>
        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>Swap Long</FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <Field name='swapLong' type='number' step={0.01} />
            </FormBaseFieldGroup>
          </FormBaseRow>
          {errors.swapLong && <FormBaseErrorMessage>{errors.swapLong}</FormBaseErrorMessage>}
        </FormBaseFieldBlock>
        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>Swap Short</FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <Field name='swapShort' type='number' step={0.001} />
            </FormBaseFieldGroup>
          </FormBaseRow>
          {errors.swapShort && <FormBaseErrorMessage>{errors.swapShort}</FormBaseErrorMessage>}
        </FormBaseFieldBlock>
        <FormBaseButtonContainer>
          <Button type='submit' onClick={() => validateForm()} className='button'>
            Save
          </Button>
        </FormBaseButtonContainer>
      </Form>
    </FormBaseContainer>
  )
}

export type EditSymbolFormValues = SymbolDto

export const BrokeragePlatformSwapsForm = withFormik<OuterProps, EditSymbolFormValues>({
  mapPropsToValues: ({ data }) => {
    return {
      name: data.name,
      marginDivider: data.marginDivider,
      swapLong: data.swapLong,
      swapShort: data.swapShort,
      selected: data.selected,
    }
  },
  handleSubmit: (values, { props, setSubmitting }) => {
    props.onSubmit(values)
    setSubmitting(false)
  },
  enableReinitialize: true,
  validate: (values) => {
    const errors: FormikErrors<EditSymbolFormValues> = {}
    if (!values.swapLong) {
      errors.swapLong = 'required'
    }
    if (!values.swapShort) {
      errors.swapShort = 'required'
    }
    return errors
  },
  isInitialValid: false,
})(BrokeragePlatformSwapsFormUI)
